export default __webpack_public_path__ + "static/media/Neddie-Screen-3.37fbffc4.png";